module.exports = __webpack_public_path__ + "tonga.svg?f77429cd5907ae62c6c998bbaef412ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/tonga.svg
// module id = 320
// module chunks = 10